'use client';

import { Button, Card, CardContent, CardHeader, CardTitle } from '@repo/ui';
import { Trash2 } from 'lucide-react';
import { type JSX, useState } from 'react';
import { ConfirmDialog } from '../confirm-dialog';

interface IDangerZoneProps {
  entityName: string;
  onDelete: () => void;
  isPending: boolean;
  error: string | null;
}

export function DangerZone({
  entityName,
  onDelete,
  isPending,
  error,
}: IDangerZoneProps): JSX.Element {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <Card className="mx-auto max-w-4xl border-destructive/50">
        <CardHeader>
          <CardTitle className="text-destructive">Danger Zone</CardTitle>
        </CardHeader>
        <CardContent>
          {error && (
            <div className="bg-destructive/10 text-destructive mb-4 rounded-md p-3 text-sm">
              {error}
            </div>
          )}
          <Button variant="destructive" onClick={() => setShowDialog(true)} disabled={isPending}>
            <Trash2 className="mr-2 h-4 w-4" />
            {isPending ? 'Deleting...' : `Delete ${entityName}`}
          </Button>
        </CardContent>
      </Card>

      <ConfirmDialog
        open={showDialog}
        onOpenChange={setShowDialog}
        onConfirm={onDelete}
        title={`Delete ${entityName}`}
        description={`Are you sure you want to delete this ${entityName.toLowerCase()}? This action cannot be undone.`}
        confirmLabel="Delete"
        variant="destructive"
      />
    </>
  );
}
